import React, { useEffect, useState } from "react";

// import components
import Footer from "../components/Footer";
import NavbarInner from "../components/Navbar-Inner";
import NavbarFixed from "../components/Navbar-Fixed";
import OrderHistory from "../components/Staking/OrderHistory";
import StakingHistory from "../components/Staking/StakingHistory";
import RedemptionHistory from "../components/Staking/RedemptionHistory";
import StackedDetail from "../components/Staking/StackedDetail";
import FooterNew from "../components/Footer-New";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";

export default function StakingHistoryPage(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div>
   
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <div className="row">
            <div className="col-xl-12">
              <StackedDetail />
              <OrderHistory />
              <StakingHistory />
              <RedemptionHistory />
            </div>
          </div>
        </div>
      </div>
      {/* <FooterNew/> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
